module.exports = __webpack_public_path__ + "img/thumbnail.6b2456ac.png";